import { GET_ALL_PARTNERS, GET_PARTNERS_DETAILS } from "./actions";

const initialState = {
  partnersList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  partnersData: {},
  loading: true,
};

const partnersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_PARTNERS:
      return {
        ...state,
        loading: false,
        partnersList: payload,
      };
    case GET_PARTNERS_DETAILS:
      return {
        ...state,
        loading: false,
        partnersData: payload,
      };

    default:
      return state;
  }
};

export default partnersReducer;
